import { onLogin, apolloClient } from "@/vue-apollo.js";
import { mutation } from "@/core/methods/mutation.js";
import { getBrowserLocation } from "@/utils/location.js";
import { getClientInfo } from "@/utils/client-info.js";
import { setSessionId } from "@/utils/session-manager.js";

const userSignIn = async (phone, password) => {
  const location = await getBrowserLocation();
  if (!location.success) {
    return location.error;
  }

  const client = getClientInfo();
  const variables = {
    phone,
    password,
    latitude: location.latitude,
    longitude: location.longitude,
    timezone: client.timezone || null,
    screenResolution: client.screenResolution || null,
  };

  try {
    const data = await mutation(variables, "user/api/signin");
    return setUserAndToken(apolloClient, data);
  } catch (error) {
    const message = error?.message || error?.graphQLErrors?.[0]?.message || "Login failed";
    return message;
  }
};

function setUserAndToken(apolloClient, data) {
  const authData = data.data.userSignIn;
  onLogin(apolloClient, authData.token);
  if (typeof localStorage !== "undefined") {
    localStorage.setItem("DONE_USER", JSON.stringify(authData.user));
    localStorage.setItem("DONE_USER_ROLE", authData.user.role);
    localStorage.setItem("DONE_USER_PERMISSIONS", authData.permissions);
    if (authData.userRoles) {
      localStorage.setItem("DONE_USER_ROLE_PERMISSIONS", JSON.stringify(authData.userRoles));
    }
    setSessionId(authData.sessionId);
  }
  return true;
}

export { userSignIn };
